import React from 'react';
import QuadProd from './QuadProd';
import { EventosDB } from '../EventosDB';

function Events() {
  return (
    <section className="services">
            <div className="container">
                <div className="row">
                    <h2>Eventos</h2>
                    
                    {
                        EventosDB.map((user, i) => {
                        return (
                            <QuadProd  
                            key={i} 
                            titulo={EventosDB[i].titulo} 
                            meio={EventosDB[i].meio}
                            link={EventosDB[i].link} 
                            data={EventosDB[i].data} 
                            text1={EventosDB[i].text1} 
                            text2={EventosDB[i].text2} 
                            icon={EventosDB[i].icon}
                            status={EventosDB[i].status}
                            />
                            );
                        })
                    }
                </div>
              </div>
    </section>
    

  );
}

export default Events;